import clsx from 'clsx'

import { Paper } from 'shared/ui/paper'
import { ResultCardDetails } from 'shared/ui/result-card-details'
import { ResultCardDetail } from 'shared/ui/result-card-details/model.ts'

import s from './styles.module.scss'

interface Props {
  title: string
  subtitle: string
  routeData: ResultCardDetail | null
}

export const DetailCard = ({ title, subtitle, routeData }: Props) => {
  if (!routeData) return

  return (
    <Paper padding={[16]}>
      <div className={s.wrapper}>
        <div className={s.header}>
          <p className={clsx('bold-17', s.title)}>{title}</p>
          <p className={clsx('regular-13', s.subtitle)}>{subtitle}</p>
        </div>
        <ResultCardDetails item={routeData} />
      </div>
    </Paper>
  )
}
